import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CloudSunIcon, UserIcon, UsersIcon, ThermometerIcon, MapPinIcon } from 'lucide-react';
interface TopBarProps {
  ceoName: string;
  isAlone: boolean;
  guestCount?: number;
}
export function TopBar({
  ceoName,
  isAlone,
  guestCount = 0
}: TopBarProps) {
  const [currentTime, setCurrentTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };
  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };
  return <motion.div initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.5
  }} className="w-full px-8 py-4 flex items-center justify-between glass-card rounded-2xl" data-id="element-596">
      {/* Left: Time & Date */}
      <div className="flex items-center gap-8" data-id="element-597">
        <div data-id="element-598">
          <div className="text-4xl font-light tracking-wide text-white" data-id="element-599">
            {formatTime(currentTime)}
          </div>
          <div className="text-sm text-gray-400 mt-1" data-id="element-600">
            {formatDate(currentTime)}
          </div>
        </div>

        {/* Weather */}
        <div className="flex items-center gap-3 pl-8 border-l border-[rgba(201,168,76,0.2)]" data-id="element-601">
          <CloudSunIcon className="w-8 h-8 text-[#C9A84C]" data-id="element-602" />
          <div data-id="element-603">
            <div className="flex items-center gap-2" data-id="element-604">
              <ThermometerIcon className="w-4 h-4 text-gray-400" data-id="element-605" />
              <span className="text-xl font-light" data-id="element-606">24°C</span>
            </div>
            <div className="flex items-center gap-1 text-xs text-gray-400" data-id="element-607">
              <MapPinIcon className="w-3 h-3" data-id="element-608" />
              <span data-id="element-609">Mumbai, India</span>
            </div>
          </div>
        </div>
      </div>

      {/* Center: Welcome Message */}
      <div className="text-center" data-id="element-610">
        <h1 className="text-2xl font-semibold font-['Playfair_Display']" data-id="element-611">
          <span className="text-white" data-id="element-612">Welcome, </span>
          <span className="text-gold-gradient" data-id="element-613">{ceoName}</span>
        </h1>
        <p className="text-sm text-gray-400 mt-1" data-id="element-614">
          {isAlone ? 'Your private workspace is ready' : `Meeting mode • ${guestCount} guest${guestCount !== 1 ? 's' : ''} present`}
        </p>
      </div>

      {/* Right: Mode Indicator */}
      <div className="flex items-center gap-4" data-id="element-615">
        <motion.div initial={{
        scale: 0.9
      }} animate={{
        scale: 1
      }} className={`flex items-center gap-3 px-5 py-3 rounded-xl ${isAlone ? 'bg-[rgba(201,168,76,0.15)] border border-[rgba(201,168,76,0.3)]' : 'bg-[rgba(59,130,246,0.15)] border border-[rgba(59,130,246,0.3)]'}`} data-id="element-616">
          {isAlone ? <>
              <UserIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-617" />
              <span className="text-[#C9A84C] font-medium" data-id="element-618">Private Mode</span>
            </> : <>
              <UsersIcon className="w-5 h-5 text-blue-400" data-id="element-619" />
              <span className="text-blue-400 font-medium" data-id="element-620">Meeting Mode</span>
            </>}
        </motion.div>

        {/* Status indicator */}
        <div className="flex items-center gap-2" data-id="element-621">
          <div className={`w-3 h-3 rounded-full ${isAlone ? 'bg-[#C9A84C]' : 'bg-blue-400'} pulse-gold`} data-id="element-622" />
          <span className="text-xs text-gray-400" data-id="element-623">System Active</span>
        </div>
      </div>
    </motion.div>;
}